type SlideImage = {
  styleName: string, 
  caption: string 
};

export const SLIDE_IMAGES: SlideImage[] = [
  {
    styleName: "lemonpie",
    caption: "Lemon pie"
  },
  {
    styleName: "chocolate-caramel-slideshow",
    caption: "Chocolate & caramel"
  },
  {
    styleName: "mignardises",
    caption: "Mignardises"
  },
  {
    styleName: "parisbrest",
    caption: "Paris-Brest"
  },
  {
    styleName: "logo",
    caption: "Kagerlighed"
  }
];

export const MENU = "Get a look at the menu";
export const DESC = [
  "My name is Eloïse, I am a Belgian-French pastry chef. I started baking when I was a little girl.", 
  "With time, my hobby turned into a passion, which after 4 years of studying became my job. My aim is to share this passion and spread happiness with my cakes.", 
  "I’m making the famous classics of French pastry and look forward to expand my selection. Most important thing to me: Everything is homemade!", 
  "From lemon meringue pie to chocolate and caramel tart, without forgetting the famous Paris-Brest, come taste a bit of France!"];